import { ReturnProcessingLevel } from "@redotech/redo-return-settings-primitives-common/return-processing-level";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getReturnProcessingLevel = unaryRpc({
  name: "getReturnProcessingLevel" as const,
  input: z.object({}),
  output: z.object({ returnProcessingLevel: z.enum(ReturnProcessingLevel) }),
});
